<script setup lang="ts">
const media = [
  {
    id: 'c39f8b9f-1254-46ba-940b-73642878fc2c',
    link: 'https://www.facebook.com/portugallerycz/',
    title: 'layout.footer.links.facebook',
    icon: '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="-204.8 -341.333 1774.933 2047.999"><path d="M1365.333 682.667C1365.333 305.64 1059.693 0 682.667 0 305.64 0 0 305.64 0 682.667c0 340.738 249.641 623.16 576 674.373V880H402.667V682.667H576v-150.4c0-171.094 101.917-265.6 257.853-265.6 74.69 0 152.814 13.333 152.814 13.333v168h-86.083c-84.804 0-111.25 52.623-111.25 106.61v128.057h189.333L948.4 880H789.333v477.04c326.359-51.213 576-333.635 576-674.373" fill="currentColor"/><path d="m948.4 880 30.267-197.333H789.333V554.609C789.333 500.623 815.78 448 900.584 448h86.083V280s-78.124-13.333-152.814-13.333c-155.936 0-257.853 94.506-257.853 265.6v150.4H402.667V880H576v477.04a687.805 687.805 0 0 0 106.667 8.293c36.288 0 71.91-2.84 106.666-8.293V880H948.4" fill="#fff"/></svg>',
  },
  {
    id: 'cee0d8a9-0549-4e57-8018-057fc3fb9dd4',
    link: 'https://twitter.com/portucz',
    title: 'layout.footer.links.twitter',
    icon: '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="-44.7006 -60.54775 387.4052 363.2865"><path fill="currentColor" d="M93.719 242.19c112.46 0 173.96-93.168 173.96-173.96 0-2.646-.054-5.28-.173-7.903a124.338 124.338 0 0030.498-31.66c-10.955 4.87-22.744 8.148-35.11 9.626 12.622-7.57 22.313-19.543 26.885-33.817a122.62 122.62 0 01-38.824 14.841C239.798 7.433 223.915 0 206.326 0c-33.764 0-61.144 27.381-61.144 61.132 0 4.798.537 9.465 1.586 13.941-50.815-2.557-95.874-26.886-126.03-63.88a60.977 60.977 0 00-8.279 30.73c0 21.212 10.794 39.938 27.208 50.893a60.685 60.685 0 01-27.69-7.647c-.009.257-.009.507-.009.781 0 29.61 21.075 54.332 49.051 59.934a61.218 61.218 0 01-16.122 2.152 60.84 60.84 0 01-11.491-1.103c7.784 24.293 30.355 41.971 57.115 42.465-20.926 16.402-47.287 26.171-75.937 26.171-4.929 0-9.798-.28-14.584-.846 27.059 17.344 59.189 27.464 93.722 27.464"/></svg>',
  },
  {
    id: '8cc96737-9a90-42d6-8eea-93d9ed5654ca',
    link: 'https://www.linkedin.com/company/portucz/mycompany/',
    title: 'layout.footer.links.linkedin',
    icon: '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="-11.494 -16.312 99.612 97.871"><path d="M72.865 61.11a1.2 1.2 0 0 0 1.21-1.27c0-.9-.543-1.33-1.657-1.33h-1.8v4.712h.677v-2.054h.832l.019.025 1.291 2.03h.724l-1.389-2.1zm-.783-.473h-.785v-1.593h.995c.514 0 1.1.084 1.1.757 0 .774-.593.836-1.314.836m-16.873-5.433h-9.6V40.17c0-3.585-.064-8.2-4.993-8.2-5 0-5.765 3.906-5.765 7.94v15.293h-9.6V24.287h9.216v4.225h.129a10.1 10.1 0 0 1 9.093-4.994c9.73 0 11.524 6.4 11.524 14.726zm-40.79-35.143a5.571 5.571 0 1 1 5.57-5.572 5.571 5.571 0 0 1-5.57 5.572m4.8 35.143h-9.61V24.287h9.61zM59.991.004H4.781A4.728 4.728 0 0 0 0 4.674v55.44a4.731 4.731 0 0 0 4.781 4.674h55.21a4.741 4.741 0 0 0 4.8-4.675V4.67a4.738 4.738 0 0 0-4.8-4.67" fill="currentColor"/><path d="M72.164 56.411a4.418 4.418 0 1 0 .085 0h-.085m0 8.33a3.874 3.874 0 1 1 3.809-3.938v.065a3.791 3.791 0 0 1-3.708 3.871h-.1" fill="currentColor"/></svg>',
  },
  {
    id: '7b47aa12-ce30-419b-979b-523ca06e8bd3',
    link: 'https://www.instagram.com/portugallerycz/',
    title: 'layout.footer.links.instagram',
    icon: '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="-100.768 -167.947 873.324 1007.682"><path d="M335.895 0c-91.224 0-102.663.387-138.49 2.021-35.752 1.631-60.169 7.31-81.535 15.612-22.088 8.584-40.82 20.07-59.493 38.743-18.674 18.673-30.16 37.407-38.743 59.495C9.33 137.236 3.653 161.653 2.02 197.405.386 233.232 0 244.671 0 335.895c0 91.222.386 102.661 2.02 138.488 1.633 35.752 7.31 60.169 15.614 81.534 8.584 22.088 20.07 40.82 38.743 59.495 18.674 18.673 37.405 30.159 59.493 38.743 21.366 8.302 45.783 13.98 81.535 15.612 35.827 1.634 47.266 2.021 138.49 2.021 91.222 0 102.661-.387 138.488-2.021 35.752-1.631 60.169-7.31 81.534-15.612 22.088-8.584 40.82-20.07 59.495-38.743 18.673-18.675 30.159-37.407 38.743-59.495 8.302-21.365 13.981-45.782 15.612-81.534 1.634-35.827 2.021-47.266 2.021-138.488 0-91.224-.387-102.663-2.021-138.49-1.631-35.752-7.31-60.169-15.612-81.534-8.584-22.088-20.07-40.822-38.743-59.495-18.675-18.673-37.407-30.159-59.495-38.743-21.365-8.302-45.782-13.981-81.534-15.612C438.556.387 427.117 0 335.895 0zm0 60.521c89.686 0 100.31.343 135.729 1.959 32.75 1.493 50.535 6.965 62.37 11.565 15.68 6.094 26.869 13.372 38.622 25.126 11.755 11.754 19.033 22.944 25.127 38.622 4.6 11.836 10.072 29.622 11.565 62.371 1.616 35.419 1.959 46.043 1.959 135.73 0 89.687-.343 100.311-1.959 135.73-1.493 32.75-6.965 50.535-11.565 62.37-6.094 15.68-13.372 26.869-25.127 38.622-11.753 11.755-22.943 19.033-38.621 25.127-11.836 4.6-29.622 10.072-62.371 11.565-35.413 1.616-46.036 1.959-135.73 1.959-89.694 0-100.315-.343-135.73-1.96-32.75-1.492-50.535-6.964-62.37-11.564-15.68-6.094-26.869-13.372-38.622-25.127-11.754-11.753-19.033-22.943-25.127-38.621-4.6-11.836-10.071-29.622-11.565-62.371-1.616-35.419-1.959-46.043-1.959-135.73 0-89.687.343-100.311 1.959-135.73 1.494-32.75 6.965-50.535 11.565-62.37 6.094-15.68 13.373-26.869 25.126-38.622 11.754-11.755 22.944-19.033 38.622-25.127 11.836-4.6 29.622-10.072 62.371-11.565 35.419-1.616 46.043-1.959 135.73-1.959" fill="currentColor"/><path d="M335.895 447.859c-61.838 0-111.966-50.128-111.966-111.964 0-61.838 50.128-111.966 111.966-111.966 61.836 0 111.964 50.128 111.964 111.966 0 61.836-50.128 111.964-111.964 111.964zm0-284.451c-95.263 0-172.487 77.224-172.487 172.487 0 95.261 77.224 172.485 172.487 172.485 95.261 0 172.485-77.224 172.485-172.485 0-95.263-77.224-172.487-172.485-172.487m219.608-6.815c0 22.262-18.047 40.307-40.308 40.307-22.26 0-40.307-18.045-40.307-40.307 0-22.261 18.047-40.308 40.307-40.308 22.261 0 40.308 18.047 40.308 40.308" fill="currentColor"/></svg>',
  },
  {
    id: 'f36e2047-94e8-4315-9a19-7a5e760d9dc1',
    link: 'https://www.youtube.com/channel/UCMIEKAa6ARfiIEjiXGPDYsw',
    title: 'layout.footer.links.youtube',
    icon: '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="-35.2 -41.333 305.067 248"><path d="M229.763 25.817c-2.699-10.162-10.65-18.165-20.748-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.553 7.652 7.6 15.655 4.903 25.817 0 44.236 0 82.667 0 82.667s0 38.429 4.903 56.85C7.6 149.68 15.553 157.681 25.65 160.4c18.3 4.934 91.682 4.934 91.682 4.934s73.383 0 91.682-4.934c10.098-2.718 18.049-10.72 20.748-20.882 4.904-18.421 4.904-56.85 4.904-56.85s0-38.431-4.904-56.85" fill="currentColor"/><path d="m93.333 117.559 61.333-34.89-61.333-34.894z" fill="#fff"/></svg>',
  },
];

function scrollTop() {
  window.scrollTo({
    top: 0,
  });
}
</script>

<template>
  <div class="contacts-and-links">
    <div class="contacts-and-links__contact">
      <a class="phone-number" :href="`tel:${$t('contact.phone.link')}`">{{
        $t('contact.phone.text')
      }}</a>
      <a class="phone-number" :href="`mailto:${$t('contact.email.address')}`">{{
        $t('contact.email.address')
      }}</a>
    </div>

    <div class="contacts-and-links__scroll-top">
      <Button variant="contained" :title="$t('layout.footer.scroll-top')" @click="scrollTop">
        <svg
          width="18"
          height="10"
          viewBox="0 0 20 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="m19 11.14-9-10-9 10" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" />
        </svg>
      </Button>
    </div>

    <div class="contacts-and-links__links">
      <a
        v-for="link in media"
        :key="link.id"
        target="_blank"
        class="external-link"
        :href="link.link"
        :title="$t(link.title)"
        v-html="link.icon"
      >
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contacts-and-links {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-areas:
    'contact scroll-top'
    'links links';
}

.contacts-and-links__contact {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.contacts-and-links__scroll-top {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;

  .button {
    display: inline-flex;

    padding: 1.125rem 0.875rem;

    border-radius: 50%;
  }
}

.contacts-and-links__links {
  grid-area: links;

  margin-top: 0.625rem;

  @media (min-width: 768px) {
    margin-top: 3.125rem;
  }

  a {
    display: inline-flex;

    &:not(:last-of-type) {
      margin-right: 1.25rem;
    }
  }
}

a {
  font-weight: 700;
  font-size: var(--font-size-base);
  text-decoration: none;
  color: var(--black);

  &:not(:hover):visited {
    color: var(--black);
  }
}
</style>
